<!-- Da dinamic form module -->
<ng-container *ngIf="group && field">
    <div class="main-outer-container" [ngClass]="field.cssClass" [formGroup]="group" [hidden]="field.hidden ? field.hidden: false">

        <!-- editable checkbox -->
        <div class="flex-col flex align-top my-2">

            <div class="">
                <label for="{{field!.name}}" [hidden]="field.hidden ? field.hidden: false" class="label">
                    {{field.label}}
                </label>
            </div>

            <div class="" *ngIf="!field.readonly">
                <!-- <ejs-checkbox [id]="field.name" #checkBoxEl (change)="onChange($event)" class="transform duration-300"
                    [formControlName]="field.name">
                </ejs-checkbox> -->

                <mat-checkbox [id]="field.name" [formControlName]="field.name" [value]="field.value"
                    (change)="onChange($event)"></mat-checkbox>
            </div>


            <div class="" *ngIf="field.readonly">
                <!-- <ejs-checkbox [id]="field.name" #checkBoxEl (change)="onChange($event)" class="transform duration-300"
                    [formControlName]="field.name">
                </ejs-checkbox> -->

                <div class="p-4 rounded-full e-icons flex flex-row justify-center items-center" style="color:white;"
                    id="{{field.name}}" [ngStyle]="{width:'1rem', height:'1rem'}"
                    [ngClass]="{'bg-red-500 e-close': field.value == false || field.value == null || field.value == undefined,'bg-emerald-500 e-check': field.value == true}">
                </div>
            </div>

        </div>

        <!--OLD ngIf *ngIf="group.controls[field.name].dirty && group.controls[field.name].invalid"-->
        <div class="flex-col flex align-top"
            *ngIf="group && field && group.controls[field!.name].dirty && group.controls[field!.name].touched">
            <ng-container *ngFor="let validation of field.validations; let i = index;">
                <div @slideDownUp *ngIf="group && field && group.controls[field.name].hasError(validation.name)"
                    class=" p-2 flex justify-start items-center gap-2 bg-red-700/50 rounded-xl text-white font-bold">

                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-6 h-6">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
                        <path d="M12 8v4" />
                        <path d="M12 16h.01" />
                    </svg>

                    <p>{{validation.message}}</p>
                </div>
            </ng-container>
        </div>

    </div>
</ng-container>

<!-- da component in html -->
<ng-container *ngIf="!group">
        <mat-checkbox #checkBoxEl></mat-checkbox>
</ng-container>
